export function formatDayTime(date: Date = new Date()): string {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  let formatted = date.toLocaleString("en-US", options);

  return formatted.replace(",", "").replace("AM", "am").replace("PM", "pm");
}

export const formatToDDMonYYYY = (input: string | Date): string => {
  if (!input) return "-";

  const date = typeof input === "string" ? new Date(input) : input;
  if (Number.isNaN(date.getTime())) throw new Error("Invalid date");

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};
